"use strict";

import React from 'react';
import {Magnifier, MOUSE_ACTIVATION, TOUCH_ACTIVATION} from "react-image-magnifiers";

const ProductGallerySlideImage = ({
                                  slide={},
                                  imgAlt='Slide',
                                  largeImgPath='/assets/img/products/large/',
                                  zoomImgPath='/assets/img/products/zoom/',
                                  magnifierProps={},
                                  magnifyImage=true,
                                  standardImgProps={}
                              }) => {
    const imgSrc = `${!!slide.enlarged_path ? slide.enlarged_path : largeImgPath}${slide.enlarged_name}`;
    const largeImgSrc = `${!!slide.zoom_path ? slide.zoom_path : zoomImgPath}${slide.zoom_name}`;

    if(magnifyImage && !!slide.zoom_name){
        const magnifierSettings = Object.assign({
            imageSrc: imgSrc,
            imageAlt: imgAlt,
            largeImageSrc: largeImgSrc,
            dragToMove: false,
            cursorStyle: 'zoom-in',
            cursorStyleActive: 'crosshair',
            mouseActivation: MOUSE_ACTIVATION.CLICK,
            touchActivation: TOUCH_ACTIVATION.DOUBLE_TAP,
            className: "magnify__images__container",
        }, magnifierProps);
        return (
            <Magnifier {...magnifierSettings} />
        );
    }
    else if(!!slide.enlarged_name){
        return (
            <div style={{height: '100%', display: 'flex',}}>
                <img src={`${largeImgPath}${slide.enlarged_name}`}
                     alt={imgAlt} className="slide__image slide__image--not-magnified" />
            </div>
        );
    }
    else
        return null;
};

export default ProductGallerySlideImage;
